module.exports = __webpack_public_path__ + "img/525704212.6781341b.jpg";